import { render, staticRenderFns } from "./PurchaseOrderStatus.vue?vue&type=template&id=4b27312c"
import script from "./PurchaseOrderStatus.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports